export const REFLECTING_LIST_ITEMSMemorila = [
  'Why was this person important to you?',
  'What would you want others to know about them?',
  'What difference did they make in your life? to others?',
  'What did you learn from them?',
  'What was something memorable about the person?',
  'Did they have favourite saying? Song? Poem?',
  'How do you think they would like to be remembered?',
];

export const REFLECTING_LIST_ITEMS0 = [
  'Why was being part of the service (CAF or RCMP) important to you?',
  'What did you learn from others you served with?',
  'What are some of your favourite memories?',
  'What are you most proud of?',
  'What were you most humbled by?',
  'What did you learn about yourself while serving?',
  'What was the most important thing you learned about yourself from serving?',
  'What would you want others to know about serving in the CAF or RCMP?',
  'How would you like to be remembered for your Service?',
  'You may find creating this brings up many memories, thoughts, and feelings you may or may not have expected. Take your time. There is no rush. You can always add to or remove things even after it has been posted.'
];

export const REFLECTING_LIST_ITEMS1 = [
  'What is your relationship to this person?',
  'Why is this person important to you?',
  'What is it about their time in service that you want them to be remembered for?',
  'When you think of them, what’s the first thing that comes to mind?',
  'What would you want others to know about them?',
  'What have you learned from them about service? About life?',
  'What do you admire most about them as someone in the service?',
  'Are there special memories of their time in service you would want to share?',
  'Do you have a special message to them from you?',
  'You may find creating this brings up many memories, thoughts, and feelings you may or may not have expected. Take your time. There is no rush. You can always add to or remove things even after it has been posted. Many have found the experience of honouring the person in this way very powerful. There may be those you invite to share in its creation who choose not to, and that’s OK too.'
];

export const REFLECTING_LIST_ITEMS2 = [
  'What was your relationship to this person?',
  'Why was this person important to you?',
  'What was it about their time in service you want others to know or remember?',
  'When you think of them, what’s the first thing that comes to mind?',
  'What difference did they make in your life? to others?',
  'What did you learn from them about service? About life?',
  'What is it about their time in service you are most proud of?',
  'How do you think they would like to be remembered?',
  'You may find creating this brings up many memories, thoughts, and feelings you may or may not have expected. Take your time. There is no rush. You can always add to or remove things even after it has been posted. Many have found the experience of honouring and remembering the person in this way helpful in their grieving, but not everyone grieves in the same way. There may be those you invite to share in its creation who choose not to, and that’s OK too.' 
];


